export const templateStatusMessages = {
  active: { id: 'template-status.active', defaultMessage: 'Active' },
  inactive: { id: 'template-status.inactive', defaultMessage: 'Inactive' },
  draft: { id: 'template-status.draft', defaultMessage: 'Draft' },
};

export const statusOptions = [
  { value: 'active', label: templateStatusMessages.active },
  { value: 'inactive', label: templateStatusMessages.inactive },
  { value: 'draft', label: templateStatusMessages.draft },
];
